import styled from 'styled-components';
import { spacingOptions, lineHeightOptions } from '../utils/utils';

export const P = styled.p`
	${spacingOptions};
	${lineHeightOptions};
`;

export const HR = styled.div`
	height: 1px;
	background-color: ${({ theme }) => theme.colors.borderColor};
	${spacingOptions};
`;
